import {Component, OnInit} from '@angular/core';
import {BaseMetadataAbstract} from "../BaseMetadata.abstract";

@Component({
    selector: 'app-meta-data-check',
    templateUrl: './meta-data-check.component.html',
    styleUrls: ['../metadata-style.scss'],
    standalone: false
})
export class MetaDataCheckComponent extends BaseMetadataAbstract<boolean, string, boolean> implements OnInit{

  protected readonly console = console;

  ngOnInit(): void {
    if(this.value !== true && this.value !== false) {
      if (this.value === 'on' || this.value >= 1 || this.value === '1') {
        this.value = true;
      } else {
        this.value = false;
      }
    }
    this.onChangeValue(this.value);
    this.onChangeHumanValue(this.value ? 'Igen' : 'Nem');
  }

  getBorderClass() {
    if(this.visibility === 'MT_O'){
      return 'disabled-border'
    } else if (this.visibility === 'MT_K' && !this.value){
      return 'warning-border'
    } else return 'active-border'
  }
}
